export const FLUX_RELATIVE_DURATION_VALIDATION_REGEX = /^-?(\d+(ns|us|ms|s|m|h|d|w|mo|y))+$/;

export const isFluxDuration = (value: unknown): value is string => {
  if (typeof value === 'string') {
    if (value === 'now()') return true;
    return FLUX_RELATIVE_DURATION_VALIDATION_REGEX.test(value);
  }
  return false;
};
